import { isOfType, ProductType, PlannerProductComponent, getProductReferenceFor, ShoppingBagComponent, InteriorComponent, OuterMeasurementsComponent, HideInSeeThroughSystemComponent, RotatableComponent } from '@inter-ikea-storageone/range';
import { RotateOrientation } from '../..';
import DistanceMeasurementComponent, { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
export const kallaxComponentResolver = (coreApi, _products, _unavailableProducts, _productsNotInMarket, _coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.KALLAX_FRAME,
        ProductType.KALLAX_DRAWERS,
        ProductType.KALLAX_BASKETS,
        ProductType.KALLAX_BOXES,
        ProductType.KALLAX_DIVIDERS,
        ProductType.KALLAX_CABINETS,
        ProductType.KALLAX_UNDERFRAME,
        ProductType.KALLAX_DESK,
        ProductType.KALLAX_TV_BENCH
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.KALLAX_FRAME,
        ProductType.KALLAX_DRAWERS,
        ProductType.KALLAX_BASKETS,
        ProductType.KALLAX_BOXES,
        ProductType.KALLAX_DIVIDERS,
        ProductType.KALLAX_CABINETS,
        ProductType.KALLAX_UNDERFRAME,
        ProductType.KALLAX_DESK,
        ProductType.KALLAX_TV_BENCH
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([
        ProductType.KALLAX_FRAME,
        ProductType.KALLAX_UNDERFRAME,
        ProductType.KALLAX_DESK,
        ProductType.KALLAX_TV_BENCH
    ]);
    const isInterior = isOfType([
        ProductType.KALLAX_BASKETS,
        ProductType.KALLAX_BOXES,
        ProductType.KALLAX_CABINETS,
        ProductType.KALLAX_DIVIDERS,
        ProductType.KALLAX_DRAWERS
    ]);
    const hideInSeeThroughEntitySystem = isOfType([
        ProductType.KALLAX_FRAME,
        ProductType.KALLAX_BASKETS,
        ProductType.KALLAX_BOXES,
        ProductType.KALLAX_CABINETS,
        ProductType.KALLAX_DIVIDERS,
        ProductType.KALLAX_DRAWERS,
        ProductType.KALLAX_DESK,
        ProductType.KALLAX_TV_BENCH
    ]);
    const shouldHaveDistanceMeasurement = isOfType([
        ProductType.KALLAX_FRAME,
        ProductType.KALLAX_TV_BENCH,
        ProductType.KALLAX_DESK,
        ProductType.KALLAX_ASSEMBLY
    ]);
    const canRotate = (entity) => {
        const productRef = coreApi.entities.getProductRef(entity);
        if (!productRef)
            return false;
        const rotateOrientation = Object.values(RotateOrientation);
        return rotateOrientation.some(orientation => productRef.includes(orientation));
    };
    const componentBuilder = {
        build: (entity) => {
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (shouldHaveDistanceMeasurement(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN, Direction.LEFT, Direction.RIGHT], [], true));
            }
            if (isPlannerProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
            }
            if (hideInSeeThroughEntitySystem(entity)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
            }
            if (canRotate(entity)) {
                entity.addComponent(new RotatableComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=kallaxComponentResolver.js.map